module.exports = __webpack_public_path__ + "img/new_logo1.90727abc.png";